export const fichaContent = {
    user: [
        { key: "nombreCompleto", label: "Nombres", type: "title" },
        { key: "dni", label: "DNI", type: "principal" },
        { key: "rol", label: "Rol", type: "principal" },
        { key: "area", label: "Area", type: "principal" },
        { key: "nombreSucursal", label: "Sucursal", type: "principal" },
        { key: "mail", label: "Correo", type: "principal" },
    ],
    porteria: [
        { key: "id", label: "ID", type: "title" },
        { key: "fecha", label: "Fecha", type: "subtitle" },
        { key: "area", label: "Sector", type: "principal" },
        { key: "tipo", label: "Tipo", type: "principal" },
        { key: "nombrePersona", label: "Persona", type: "principal" },
        { key: "tractorFull", label: "Tractor", type: "principal" },
        { key: "parteTr", label: "Parte Tractor", type: "boolean" }, //especial
        { key: "servicio", label: "servicio", type: "principal" },
        { key: "furgonFull", label: "Carga / Furgón", type: "principal" },
        { key: "vehiculo", label: "Vehiculo", type: "principal" },
        { key: "detalle", label: "Detalle", type: "principal" },
        { key: "chequeos", label: "Chequeos", type: "chequeos" }, //especial
        { key: "usuario", label: "Cargado por", type: "footer" },
        { key: "modificaciones", label: "Modificaciones", type: "modificaciones" }
    ],
    satelital: [
        { key: "id", label: "ID", type: "title" },
        { key: "fecha", label: "Fecha", type: "subtitle" },
        { key: "area", label: "Sector", type: "principal" },
        { key: "tipo", label: "Tipo", type: "principal" },
        { key: "nombrePersona", label: "Persona", type: "principal" },
        { key: "tractorFull", label: "Tractor", type: "principal" },
        { key: "furgonFull", label: "Carga / Furgón", type: "principal" },
        { key: "vehiculo", label: "Vehiculo", type: "principal" },
        { key: "detalle", label: "Detalle", type: "principal" },
        { key: "cliente", label: "Cliente", type: "secondary" },
        { key: "nombrePersonaRelacionada", label: "Persona (relacionada)", type: "secondary" },
        { key: "tractorRelacionadoFull", label: "Tractor (relacionado)", type: "secondary" },
        { key: "usuario", label: "Cargado por", type: "footer" },
        { key: "modificaciones", label: "Modificaciones", type: "modificaciones" }
    ],
    taller: [
        { key: "id", label: "ID", type: "title" },
        { key: "fecha", label: "Fecha", type: "subtitle" },
        { key: "area", label: "Sector", type: "principal" },
        { key: "tipo", label: "Tipo", type: "principal" },
        { key: "nombreSucursal", label: "Sucursal", type: "principal" },
        { key: "nombreMecanico", label: "Mecanico", type: "principal" },
        { key: "nombreServicio", label: "Hecho por", type: "principal" },
        { key: "tractorFull", label: "Tractor", type: "principal" },
        { key: "kilometraje", label: "Kilometraje", type: "principal" },
        { key: "furgonFull", label: "Furgon", type: "principal" },
        { key: "repuestos", label: "Repuestos utilizados", type: "items" }, // especial
        { key: "usuario", label: "Cargado por", type: "footer" },
        { key: "modificaciones", label: "Modificaciones", type: "modificaciones" } // especial
    ],
    tractores: [
        { key: "id", label: "Interno", type: "title" },
        { key: "dominio", label: "Dominio", type: "principal" },
        { key: "marca", label: "Marca", type: "principal" },
        { key: "modelo", label: "Modelo", type: "principal" },
        { key: "motor", label: "Motor", type: "principal" },
        { key: "chasis", label: "Chasis", type: "principal" },
        { key: "detalle", label: "Detalle", type: "principal" },
        { key: "nombreEmpresa", label: "Empresa", type: "secondary" },
        { key: "nombreResponsable", label: "A cargo", type: "secondary" },
        { key: "nombreSatelital", label: "Satelital", type: "secondary" },
        { key: "detalleSatelital", label: "Detalle (satelital)", type: "secret" }, // restringido
        { key: "comentarioSatelital", label: "Comentario (satelital)", type: "secret" }, // restringido
    ],
    furgones: [
        { key: "id", label: "Interno", type: "title" },
        { key: "dominio", label: "Dominio", type: "principal" },
        { key: "marca", label: "Marca", type: "principal" },
        { key: "modelo", label: "Modelo", type: "principal" },
        { key: "detalle", label: "Detalle", type: "principal" },
        { key: "nombreEmpresa", label: "Empresa", type: "secondary" },
    ],
    vehiculos: [
        { key: "id", label: "Dominio", type: "title" },
        { key: "marca", label: "Marca", type: "principal" },
        { key: "modelo", label: "Modelo", type: "principal" },
        { key: "motor", label: "Motor", type: "principal" },
        { key: "chasis", label: "Chasis", type: "principal" },
        { key: "detalle", label: "Detalle", type: "principal" },
        { key: "nombreEmpresa", label: "Empresa", type: "secondary" },
        { key: "nombreResponsable", label: "A cargo", type: "secondary" },
        { key: "nombreSatelital", label: "Satelital", type: "secondary" },
        { key: "detalleSatelital", label: "Detalle (satelital)", type: "secret" }, // restringido
        { key: "comentarioSatelital", label: "Comentario (satelital)", type: "secret" }, // restringido
    ],
    personas: [
        { key: "apellido", label: "apellido", type: "title" },
        { key: "nombres", label: "nombres", type: "secondtitle" },
        { key: "id", label: "DNI", type: "principal" },
        { key: "nacimiento", label: "Nacimiento", type: "PRIMA" },
        { key: "ubicacion", label: "Ubicación", type: "principal" },
        { key: "legajo", label: "Legajo", type: "secondary" },
        { key: "nombreEmpresa", label: "Empresa", type: "secondary" },
        { key: "ingreso", label: "Ingreso", type: "secondary" },
        { key: "tipo", label: "Relación", type: "secondary" },
        { key: "puestoCompleto", label: "Puesto", type: "secondary" },
        { key: "sucursal", label: "Sede", type: "secondary" },
        { key: "detalle", label: "Detalle", type: "secondary" },
        { key: "estado", label: "Estado", type: "state" },
    ],
    stock: [
        { key: "id", label: "Codigo", type: "title" },
        { key: "codigoProveedor", label: "Codigo Proveedor", type: "secondtitle" },
        { key: "descripcion", label: "Descripcion", type: "principal" },
        { key: "tipo", label: "Tipo", type: "principal" },
        { key: "marca", label: "Marca", type: "principal" },
        { key: "nombreProveedor", label: "Proveedor", type: "principal" },
        { key: "detalle", label: "Detalle", type: "principal" },
        { key: "cantidad", label: "Cantidad", type: "secondary" },
        { key: "unidad", label: "Unidad de medida", type: "secondary" },
        { key: "porDeposito", label: "Por depósito", type: "secondary" },
    ],
    proveedores: [
        { key: "id", label: "Codigo", type: "title" },
        { key: "cuit", label: "Cuit", type: "principal" },
        { key: "nombre", label: "Nombre", type: "principal" },
        { key: "marca", label: "Marca", type: "principal" },
        { key: "detalle", label: "Detalle", type: "principal" },
    ],
    asignaciones: [
        { key: "id", label: "Codigo", type: "title" },
        { key: "fecha", label: "Fecha", type: "principal" },
        { key: "nombrePersona", label: "Persona", type: "principal" },
        { key: "articulo", label: "Articulo", type: "secondary" },
        { key: "nombreArticulo", label: "Descripcion", type: "secondary" },
        { key: "cantidadFull", label: "Cantidad", type: "secondary" },
        { key: "UnidadArticulo", label: "Unidad de medida", type: "secondary" },
        { key: "detalle", label: "Detalle", type: "secondary" },
    ],
    traficoSatelital: [
        { key: "id", label: "Codigo", type: "title" },
        { key: "fecha", label: "Fecha", type: "principal" },
        { key: "tipo", label: "Tipo", type: "principal" },
        { key: "nombrePersona", label: "Persona", type: "principal" },
        { key: "nombreTractor", label: "Tractor", type: "principal" },
        { key: "detalle", label: "Detalle", type: "principal" },

    ],
}


// grafica para types:

/*
     _______________________
    |                       |
    |         title         |
    |_______________________|
    |                       |
    |        subtitle       |
    |_______________________|
    |                       |
    |       principal       |
    |_______________________|
    |                       |
    |       secondary       |
    |_______________________|
    |                       |
    |         footer        |
    |_______________________|

*/